namespace GeniuzPOS.Purchase {
    export interface UpdateCancelAndIrUseFgRequest {
        SysDocNo?: string;
        CancelFg?: number;
        IrUseFg?: number;
    }
}
